import axios from '__js__/axios';
import reverse from 'django-reverse';
import { AxiosResponse } from 'axios';

const url = 'membership_api:membership_user';

export const fetchFetchMembershipUser = async (): Promise<AxiosResponse> =>
	await axios.get(reverse(url));
